import WorkflowCanvas from '@components/workflow/WorkflowCanvas';
import WorkflowSideNav from '@components/workflow/WorkflowSidenav/WorkflowSidenav';
import { Routes } from '@helpers/_routes';
import { AssignmentTypes, NewWorkflow, WorkflowRectTypes } from '@helpers/Enums';
import { ComponentType } from '@interfaces/component-type';
import WorkflowService from '@services/global/Workflow';
import newWorkflowService from '@services/graphQL/graphQLWorkflow';
import UserGroupService from '@services/UserGroupService';
import NotificationComponent from '@src/helpers/_showNotifications';
import ProcessRequestsInterceptor from '@src/helpers/interceptors/ProcessRequestInterceptor';
import I18n from '@src/i18n';
import styled from '@src/styled-components';
import mermaid from 'mermaid';
import React from 'react';
import uuid from 'uuidv4';
import { safePropertieRetrieve } from '@src/helpers/validation/ObjectValidator';
import WorkflowConditionModal from '../components/workflow/WorkflowCondition/WorkflowConditionsModal';
import IWorkflow from '../interfaces/IWorkflow';
import GroupService from '@services/graphQL/graphQLGroup'

const groupService = new GroupService()
const _formflowService: ProcessRequestsInterceptor = new ProcessRequestsInterceptor();


type PropType = {
    history: { replace: Function };
    match: any;
}
type StateType = {
    radioProcess: boolean;
    isLoading: boolean;
    svg: any;
    selectedProcessData: any;
    selectedProcessId?: string
    processes: any;
    workflow?: IWorkflow[];
    workflowNodes: any;
    diamondLength: number;
    sideNavVisible: boolean;
    groups: any;
    actualNode?: any;
    shouldUpdatedata: boolean;
    nodeData?: {
        groups: string[],
        selectedProcessId?: string,
        radioProcess?: boolean,
        notification?: {
            type?: number,
            message: string
        }
    },
    checkForBrokenWorkflow: boolean;
    workflowName: string;
    conditionModalVisibility: boolean;
    filteredAvailebProcessToCondition: any;
    currentConditionNexts: any;
    conditionData: any;
    loading: boolean;
}


export default class WorkflowContainer extends React.Component<PropType, StateType> {

    private unitId: string = localStorage.getItem('activeUnitId') || '';
    private _workflowService: WorkflowService = new WorkflowService();
    private workflowServiceNew: any = new newWorkflowService();
    private _userGroupService: UserGroupService;
    

    constructor (props: any) {
        super(props);
        this._userGroupService = new UserGroupService();

        mermaid.initialize({
            startOnLoad: false,
            sequence: {
                useMaxWidth: true
            },
            flowchart: {
                htmlLabels: true,
            }
        })

    }

    state = {
        radioProcess: false,
        isLoading: true,
        processes: [],
        svg: '',
        selectedProcessId: '',
        workflow: undefined,
        workflowNodes: [],
        rectangleWidth: 140,
        rectangleHeight: 80,
        diamondLength: 115,
        distanceBetweenRects: 250,
        sideNavVisible: false,
        actualNode: undefined, 
        groups: [],
        shouldUpdatedata: false,
        checkForBrokenWorkflow: false,
        workflowName: '',
        conditionModalVisibility: false,
        filteredAvailebProcessToCondition: [],
        currentConditionNexts: [],
        conditionData: undefined,
        loading: true
    }

    async handleClick (e: any) {
        e.preventDefault();
    }

    getWorkflowData = async () => {
        let workflow;
        
        if(this.props.match && this.props.match.params && this.props.match.params.id){
            if(this.props.match.params.id !== NewWorkflow.url){
                const workflowId = this.props.match.params.id
                workflow = await this.workflowServiceNew.getWorkflows(workflowId);
            }
        }
        
        let workflowName;
        if(workflow && workflow.getWorkflow && workflow.getWorkflow.name){
            workflowName = workflow.getWorkflow.name
        }


        if(workflow && workflow.getWorkflow){
            const { nodes } = workflow.getWorkflow
            for(let node of nodes){
                if(node.properties.connectedToStart) {
                    const from = node.from
                    from.push('start')
                    node.from = from
                }
                if(node.properties.connectedToEnd){
                    let next = node.next
                    if(Array.isArray(next)){
                        next.push('end')
                    } else {
                        next = ['end']
                    }
                    node.next = next
                }
                if(node.assigned && node.assigned.length > 0){
                    node.group = node.assigned.map((e:any) => e.to)
                    delete node.assigned
                }
                if(node.type === WorkflowRectTypes.CONDITION){
                    this.formatCondition(node);
                }
                if(node.type === WorkflowRectTypes.PROCESS){
                    let name = safePropertieRetrieve(node, 'properties.name')
                    node.name = name
                    node.process = {id: node.process_id, name }
                }
                node.x = node.properties.x
                node.y = node.properties.y
                node.breadth = node.properties.breadth
                node.afterTime = node.properties.afterTime
                delete node.properties
            }
            
            //delete nodes[nodes.length - 1].next 

            this.setState({workflowNodes: nodes, workflowName})
        } else {
            this.setState({workflowNodes: []})
        }
    }

    formatCondition = async (node: any) => {
        if(node.condition){
            
            node.conditions = node.condition
            delete node.condition
            
            node.elseNext = node.next[0]

            //The next propertie is set to an empty array because it contains the elseNext value
            //but since the elseNext value also is contained in a condition, if I did'n clean the next
            //the same value would appear twice
            
            node.next = [];

            for(let condition of node.conditions){
                node.next.push(condition.workflow_node_out)
                condition.next = condition.workflow_node_out
                delete condition.workflow_node_out
            }
        }
    }

    includeStartAndFinish = (nodes: any) => {
        const start = {
            id: 'start',
            x: 140,
            y: 321,
            type: WorkflowRectTypes.START,
            fontColor: '#ffffff',
            from: null
        }
        const end = {
            id: 'end',
            x: window.innerWidth - 340,
            y: 321,
            type: WorkflowRectTypes.END,
            fontColor: '#ffffff',
            to: null
        }
        let furthestNodeX = 0
        if(nodes.length > 0){
            for(let node of nodes){
                if(node.from && node.from.includes('start')){
                    if(start.next){
                        start.next.push(node.id)
                    } else {
                        start.next = [ node.id ]
                    }
                }
                if(node.next && node.next.includes('end') || !node.next){
                    if(node.x > furthestNodeX){
                        furthestNodeX = node.x
                    }

                    if(!node.next){
                        node.next = ['end']
                    }
                    if(node.next){
                        if(!node.next.includes('end')){
                            node.next.push('end')
                        }
                    }
                    if(end.from){
                        end.from.push(node.id)
                    } else {
                        end.from = [ node.id ]
                    }
                }
            }
        }
        if(furthestNodeX > 0) {
            end.x = furthestNodeX + (this.state.rectangleWidth * 2)
        }
        nodes.push(start, end)
        this.setState({ workflowNodes: nodes })
    }

    retrieveNodeState = async (node: any) => {
        if(node.type === WorkflowRectTypes.PROCESS){
            const nodeData = {
                id: node.id,
                type: WorkflowRectTypes.PROCESS,
                groups: node.group,
                selectedProcessId: node.process ? node.process.id : undefined,
                radioProcess: node.executedAnytime,
                afterTime: node.afterTime
            }
            
            this.setState({ nodeData })

        } if (node.type === WorkflowRectTypes.NOTIFICATION) {
            const nodeData = {
                id: node.id,
                type: WorkflowRectTypes.NOTIFICATION,
                groups: node.group,
                notification : node.notification ? {
                    type: node.notification.type,
                    message: node.notification.message,
                    title: node.notification.title,
                    extractAnswers: node.notification.extractAnswers
                } : undefined
            } 
            this.setState({ nodeData })
        } if(node.type === WorkflowRectTypes.CONDITION) {
            if(node.conditions){
                const conditions = node.conditions.map((cond: any, index: number) => {
                    return {
                        id: cond.id,
                        index: index + 1,
                        operation: cond.operation,
                        next: cond.next,
                        rules: cond.rules.map((rule: any) => Object.assign({}, rule, {id: uuid()}))
                    }
                })
                const conditionData = {
                    conditions,
                    elseNext: node.next[0]
                }
                this.setState({ conditionData })
            }
        }
    }
    
    openSideNav = async (node: any) => {
        this.setState({sideNavVisible: true, actualNode: node})
    }
    
    checkForConditionInNext = (node: any) => {
        let connectedToCondition = false
        const { workflowNodes } = this.state
        for(let nextNodeID of node.next){
            const nextNode = workflowNodes.find((node) => node.id === nextNodeID)
            if(nextNode.type === WorkflowRectTypes.CONDITION){
                connectedToCondition = false;
                break;    
            }
        }
        return connectedToCondition
    }

    toggleConditionsModalVisibility = (node?: any) => {
        this.setState({sideNavVisible: false})
        if(node.id){
            this.setState({actualNode: node})
            this.retrieveNodeState(node)
            const { workflowNodes } = this.state
            const connectedProcesses: any = []
            for( let wfNode of workflowNodes){
                if(node.from.includes(wfNode.id) && wfNode.type === WorkflowRectTypes.PROCESS){
                    connectedProcesses.push(wfNode)
                }
            }
            if(connectedProcesses.length > 0 ){
                if(node.next && node.next.length > 1){
                    const isConnectedToCondition = this.checkForConditionInNext(node)
                    if(!isConnectedToCondition){
                        this.setProcessesAvailableToCondition(connectedProcesses);
                        this.setState((prevState) => ({ conditionModalVisibility: !prevState.conditionModalVisibility }));
                        this.setcurrentConditionNexts(node.next);
                    } else {
                        NotificationComponent.Notify('error', I18n.l('common.error'), I18n.l('workflow.error.condition.direct.connection'));
                    }
                    
                } else {
                    NotificationComponent.Notify('error', I18n.l('common.error'), I18n.l('workflow.condition.next.length.error'));
                }
            } else {
                NotificationComponent.Notify('error', I18n.l('common.error'), I18n.l('workflow.condition.connection.error'));
            }
        } else {
            this.setState((prevState) => ({ conditionModalVisibility: !prevState.conditionModalVisibility }))
        }
    }

    
    formatConditionNexts = (unformattedNodes: any[]) => {
        const formattedNodes: any = [];
        if(unformattedNodes && unformattedNodes.length > 0){
            for(let node of unformattedNodes){
                const formattedNode = {
                    id: node.id
                }
                switch(node.type){
                    case WorkflowRectTypes.PROCESS:
                        formattedNode.title = node.process.name;
                        break;
                    case WorkflowRectTypes.NOTIFICATION:
                        formattedNode.title = node.notification.title;
                        break;
                }
                formattedNodes.push(formattedNode);
            }
        }
        return formattedNodes;
    }
    
    setcurrentConditionNexts = async (nextNodes: string[]) => {
        const { workflowNodes } = this.state
        const availableNexts = nextNodes.map((nextNodeID: any) => workflowNodes.find((node:any) => node.id === nextNodeID))
        const currentConditionNexts = this.formatConditionNexts(availableNexts)
        this.setState({currentConditionNexts})
    }
    
    clearConditionState = async () => {
        this.setState({
            filteredAvailebProcessToCondition: undefined,
            currentConditionNexts: undefined
        })
    }

    onConditionsModalCancel = () => {
        this.setState({ conditionModalVisibility: false, conditionData: undefined, sideNavVisible: false})
    }

    setProcessesAvailableToCondition = async (connectedProcesses: any) => {
        if(connectedProcesses.length > 0){
            const { processes } = this.state
            const availableProcessToCondition: any = []
            connectedProcesses.forEach((node: any) => {
                const actualProcess = processes.items.find((process: any) => process.id === node.process.id)
                availableProcessToCondition.push(actualProcess)
            });
            

            const filteredAvailebProcessToCondition : any = []

            for(let atributes of availableProcessToCondition){
                filteredAvailebProcessToCondition.name = atributes.name;
                filteredAvailebProcessToCondition.id = atributes.id;
            }
            
            filteredAvailebProcessToCondition.sections = [];
            for(let processFiltered of availableProcessToCondition){
                for(let filteredSection of processFiltered.sections){
                    var availableComponents: any = []
                    let haveComponent = false;
                    for(let filteredComponent of filteredSection.components){
                        if(filteredComponent.type === ComponentType.SELECT){
                            availableComponents.push(filteredComponent);
                            haveComponent = true;
                        }
                    }
                    if(haveComponent){
                        filteredSection.components = availableComponents
                        filteredAvailebProcessToCondition.sections.push(filteredSection)
                    }
                    
                }
            }
            
            this.setState({filteredAvailebProcessToCondition})
        }
    }
    
    clearSidenavState = async () => {
        this.setState({ nodeData: undefined })
    }

    closeSidenav = async () => {
        this.setState({sideNavVisible: false })
        this.clearSidenavState()
    }

    formatWorkflowdata = async () => {
        let { workflowNodes } = this.state
        await this.includeStartAndFinish(workflowNodes)
        if(workflowNodes && workflowNodes.length > 0){
            for(let node of workflowNodes){
                switch(node.type){
                    case WorkflowRectTypes.PROCESS:
                        node.color = "#335D7C";
                        node.fontColor = "#335D7C";
                        break;
                    case WorkflowRectTypes.NOTIFICATION:
                        node.color = "#C19807";
                        node.fontColor = "#C19807";
                        break;
                    case WorkflowRectTypes.CONDITION:
                        node.color = "#53BFC9";
                        node.fillColor = "#53BFC9";
                        node.rotation = 45;
                        node.fontColor = "#fff";
                        break;
                    default:
                        break;
                    }
                    this.createWorkflowLines(node)
                    this.createWorkflowicons(node)
            }
        }
        this.setState({workflowNodes: workflowNodes})
    }

    saveConditionInfo = async (conditions: any, elseNext: any) => {
        const { workflowNodes, actualNode } = this.state;
        const condition = Object.assign({}, actualNode, {conditions, elseNext})

        const currentNodeIndex = workflowNodes.findIndex((node: any) => node.id === actualNode.id)
        workflowNodes[currentNodeIndex] = condition;

        this.setState({workflowNodes});
    }

    createWorkflowLines = async (node: any) => {
        const { workflowNodes, rectangleWidth, rectangleHeight, diamondLength } = this.state
            if(node.next){
                for(let nextNode of node.next){
                    const toNode = workflowNodes.find((node: any) => node.id === nextNode)
                    const line = {
                        fromX: node.x + rectangleWidth + 5,
                        fromY: node.y + (rectangleHeight / 2),
                        toX: toNode.x - 5,
                        toY: toNode.y + (rectangleHeight / 2),
                        toId: toNode.id
                    }
                    if(toNode.type === WorkflowRectTypes.END){
                        line.toX = toNode.x - 45
                        line.toY = toNode.y
                    }
                    if(node.type === WorkflowRectTypes.START){
                        line.fromX = node.x + 45
                        line.fromY = node.y
                    }
                    if(node.type === WorkflowRectTypes.CONDITION){
                        line.fromX = node.x + (diamondLength / 2) + 5
                        line.fromY = node.y + (rectangleHeight / 2) + 15
                    }
                    if(toNode.type === WorkflowRectTypes.CONDITION){
                        line.toX = toNode.x - (diamondLength / 2) - 5
                        line.toY = toNode.y + (rectangleHeight / 2) + 15
                    }
                    if(node.line){
                        node.line.push(line)
                    } else {
                        node.line = [line]
                    }
                }
            }
        }
    
    getGroups = async () => {
        try {
        let { listUserGroups }: any = await groupService.listUserGroups()
        this.setState({ groups: listUserGroups })
    
        } catch (e) {
          console.error(e)
        }
    }
    
    redirect = () => {
        this.props.history.push(`${Routes.workflows}`)
    }

    filterProcessByType = async (model: any, componentType: ComponentType) => {
        const filtered: any = {
          items: []
        };
        model.items.map((process: any, i: number) => {
          for (let section of process.sections) {
            if (section.components.findIndex((e: any) => e.type === componentType) !== -1) {
              if (filtered.items.findIndex((p: any) => p.id === model.items[i].id) === -1) {
                filtered.items.push(model.items[i])
              }
            }
          }
        })
        return filtered
    }
    
    getProcesses = async () => {

        const data = await _formflowService.paging({
            unit: this.unitId,
            to: undefined,
            from: undefined,
            limit: 100,
          }, ['id', 'name', 'paths', 'sections']);
    
        this.setState({ processes: data , loading: false})

      }


    createWorkflowicons = (node: any) => {
        let labelText;
        let [x,y] = [35, 10];
        let [closePosX, closePosY] = [140, 1]
        node.icon = { posX: 5, posY: 5 }
        let [newLinePosX, newLinePosY] = [150,8]
        switch(node.type){
            case WorkflowRectTypes.CONDITION:
                labelText = I18n.l('process.conditionTitle');
                newLinePosX = 40
                newLinePosY = 15
                x = -37
                y = 50
                delete node.icon
                break;
            case WorkflowRectTypes.PROCESS:
                labelText = I18n.l('labels.processTitle');
                break;
            case WorkflowRectTypes.NOTIFICATION:
                labelText = I18n.l('labels.notification');
                break;
            case WorkflowRectTypes.START:
                delete node.icon
                labelText = I18n.l('history.audits.labels.start')
                newLinePosX = 40
                newLinePosY = - 38
                x = -19                           
                y = -8                    
                break;
            case WorkflowRectTypes.END:
                delete node.icon
                labelText = I18n.l('history.audits.labels.end')
                x = -13
                y = -8
                break;
        }
        node.label = {
            text: labelText,
            posX: x,
            posY: y,
        }
        if(node.type !== WorkflowRectTypes.END){
            node.newLineIcon = {
                posX: newLinePosX,
                posY: newLinePosY
            }
        }
        if(node.type !== WorkflowRectTypes.START && node.type !== WorkflowRectTypes.END){
            node.close = {
                posX: node.type === WorkflowRectTypes.CONDITION ? 10 : closePosX,
                posY: node.type === WorkflowRectTypes.CONDITION ? 5 : closePosY
            }
        }
    }

    updateNodesArray = async (nodeArray: any, id?: string) => {
        if(id) nodeArray = nodeArray.filter((node: any) => node.id !== id)
        this.setState({workflowNodes: nodeArray})
    }
    
    componentDidMount () {        
        this.initialData()
    }

    initialData = async () => {
        await this.getWorkflowData();
        await this.formatWorkflowdata();
        await this.getGroups();
        await this.getProcesses();
    }

    saveSidenav = async (sideNavData: any) => {
        const { actualNode, workflowNodes, processes } = this.state
        const actualNodeIndex = workflowNodes.findIndex((node: any) => node.id === actualNode.id)

        if(actualNode.type === WorkflowRectTypes.PROCESS) {
            const process = processes.items.find((process: any) => process.id === sideNavData.process)
            workflowNodes[actualNodeIndex].process = {
                id: process.id,
                name: process.name
            }
            workflowNodes[actualNodeIndex].name = process.name
            workflowNodes[actualNodeIndex].group = sideNavData.groups
            workflowNodes[actualNodeIndex].executedAnytime = sideNavData.executedAnytime
            workflowNodes[actualNodeIndex].afterTime = sideNavData.afterTime
        } else {
            workflowNodes[actualNodeIndex].group = sideNavData.groups
            workflowNodes[actualNodeIndex].notification = sideNavData.notification
        }


        if(workflowNodes[actualNodeIndex].broken && workflowNodes[actualNodeIndex].broken.unfilled){
            delete workflowNodes[actualNodeIndex].broken.unfilled
            if(Object.keys(workflowNodes[actualNodeIndex].broken).length === 0){
                this.regularNodeStyler(workflowNodes[actualNodeIndex])
            }
        }
        
        this.setState({shouldUpdatedata: true})
        this.closeSidenav()
    }

    regularNodeStyler = (node: any) => {
        if(node.type !== WorkflowRectTypes.CONDITION){
          delete node.fillColor
          node.color = node.type === WorkflowRectTypes.NOTIFICATION ?  '#C19807' : '#335D7C';
          node.fontColor = node.type === WorkflowRectTypes.NOTIFICATION ?  '#C19807' : '#335D7C';
        } else {    
          node.color = '#53BFC9'
          node.fillColor = '#53BFC9'
        }
        delete node.broken
    }

    dataUpdated = async () => {
        this.setState({shouldUpdatedata: false})
    }

    checkEndOrStartExistence = (formattedNode: any) => {
        formattedNode
        if(formattedNode.next){
            if(formattedNode.next.indexOf('end') !== -1){
                formattedNode.next = formattedNode.next.filter((e: any) => e !== 'end');
                formattedNode.properties.connectedToEnd = true;
            }
        }
    }
    
    formatDataToAPI = () => {
        const notifications = []
        const nodes = []
        for(let node of this.state.workflowNodes){
            if(node.type === WorkflowRectTypes.END || node.type === WorkflowRectTypes.START){
                continue;
            }
            const formattedNode = {
                id: node.id,
                    properties: {
                        x: node.x,
                        y: node.y,
                        breadth: node.breadth,
                        afterTime: node.afterTime
                    },
                type: node.type,
                next: node.next,
                from: node.from,
                assigned: node.breadth !== 0 && node.type !== WorkflowRectTypes.CONDITION? node.group.map((assigned: any) => {return {to: assigned, type: AssignmentTypes.GROUP}}) : []
            }
            if(node.type === WorkflowRectTypes.CONDITION){
                const conditions = node.conditions
                for(let condition of conditions){
                    delete condition.index
                    delete condition.workflow_node_id
                    for(let rule of condition.rules){
                        delete rule.id
                    }
                }
                formattedNode.next = [node.elseNext]
                formattedNode.conditions = conditions
            }
            if(Array.isArray(node.assigned) && node.assigned.length === 0){
                delete node.assigned
            }
            if(node.type === WorkflowRectTypes.PROCESS){
                formattedNode.name = node.name
                formattedNode.process_id = node.process.id
                if(node.breadth > 0 ){
                    formattedNode.runAfter = node.afterTime.timeInSeconds
                    formattedNode.properties.aftertime = node.aftertime
                }
                formattedNode.properties.name =  node.name
            } else if (node.type !== WorkflowRectTypes.CONDITION) {
                formattedNode.notification_id = node.notification.id
                let title;
                if(node.notification.title) title = node.notification.title
                else title = 'Notification'
                notifications.push({
                    id: node.notification.id,
                    title,
                    type: node.notification.type,
                    message: node.notification.message,
                    extractAnswers: node.notification.extractAnswers
                })
            }
            if(node.breadth === 0) { 
                formattedNode.from = []
                formattedNode.properties = {...formattedNode.properties, connectedToStart: true}
            }
            if(node.next && node.next.includes('end')){
                formattedNode.next = []
                if(formattedNode.next && formattedNode.next.length > 0){
                    formattedNode.next.filter((e: any) => e !== 'end')
                } else {
                    formattedNode.next = []
                }
                formattedNode.properties = {...formattedNode.properties, connectedToEnd: true}
            }
            this.checkEndOrStartExistence(formattedNode)
            nodes.push(formattedNode)
        }
        return {nodes, notifications}
    }
    
    workflowValidator = async (isBroken: boolean) => {
        if(!isBroken){
            const { workflowName } = this.state
            const savedData = this.formatDataToAPI()
            const sentData = Object.assign({}, savedData, {name: workflowName});

            try {
                if(this.props.match.params.id === NewWorkflow.url){
                    const res = await this.workflowServiceNew.InputWorkflows(sentData);
                    if(res.errors){
                        throw new Error();       
                    }else{
                        NotificationComponent.Notify('success', I18n.l('common.saved'), I18n.l('workflow.save.success'))
                    }
                } else {
                    const res = await this.workflowServiceNew.updateWorkflow(this.props.match.params.id, sentData)
                    if(res.errors){
                        throw new Error();       
                    }else{
                        NotificationComponent.Notify('success', I18n.l('common.saved'), I18n.l('workflow.save.success'))
                    }
                }
                this.redirect()
            } catch{
                NotificationComponent.Notify('error', I18n.l('common.save.error'), I18n.l('workflow.save.error'))
            }
        } else {
            if(isBroken.connectionError) NotificationComponent.Notify('error', I18n.l("workflow.connection.error"), I18n.l('workflow.validation.broken.workflow'));
            if(isBroken.unfilledNodes) NotificationComponent.Notify('error', I18n.l("workflow.connection.error"), I18n.l('workflow.unfilled.nodes'));
            if(isBroken.conditionless) NotificationComponent.Notify('error', I18n.l("workflow.connection.error"), I18n.l('workflow.error.unfilled.condition.rules'));
        }
    }

    saveWorkflow = async () => {      
        const { workflowNodes, workflowName } = this.state 
        if(workflowNodes.length > 2){
            if(this.state.workflowName){
                if(this.state.workflowName.length <= 80){
                    this.setState({checkForBrokenWorkflow: true})
                } else {
                    NotificationComponent.Notify('error', I18n.l("workflow.connection.error"), I18n.l('workflow.name.size'))    
                }
            }else {
                NotificationComponent.Notify('error', I18n.l("workflow.connection.error"), I18n.l('workflow.error.nameless'))
            }
        } else {
            NotificationComponent.Notify('error', I18n.l("workflow.connection.error"), I18n.l('workflow.error.nodes'))     
        }
    }

    workflowChecked = async () => {
        this.setState({checkForBrokenWorkflow: false})
    }
    workflowNameHandler = async (e: any) => {
        this.setState({ workflowName: e.target.value })
    }

    render() {
        const {
            actualNode, 
            sideNavVisible,
            groups,
            processes,
            checkForBrokenWorkflow,
            conditionModalVisibility,
            filteredAvailebProcessToCondition,
            currentConditionNexts,
            conditionData
        } = this.state;

        const workflowData = this.state.workflowNodes
        return (
            <div style={{maxWidth: '100%', width: '100%', paddingTop: '100px', paddingLeft: '180px', maxHeight: '100%', height: '100vh', position: 'relative'}}>
                <WorkflowConditionModal 
                visibility={conditionModalVisibility}
                onConditionsModalCancel={this.onConditionsModalCancel}
                availableProcess={filteredAvailebProcessToCondition}
                currentConditionNexts={currentConditionNexts}
                saveConditionInfo={this.saveConditionInfo}
                conditionData={conditionData}
                clearConditionState={this.clearConditionState}
                />
                <WorkflowHeader >
                    <div className="textArea">
                        <input className="workflow-name" onChange={this.workflowNameHandler} value={this.state.workflowName} placeholder={I18n.l('workflow.name')}/>
                    </div>
                    <div className="options">
                        <button onClick={this.redirect} className="cancel margin-right">{I18n.l('common.cancel')}</button>
                        <button onClick={this.saveWorkflow} id="save-workflow" className="save">{I18n.l('common.save')}</button>
                    </div>

                </WorkflowHeader>
                <WorkflowCanvas 
                    data={workflowData}
                    rectangleWidth={this.state.rectangleWidth}
                    rectangleHeight={this.state.rectangleHeight}
                    diamondLength={this.state.diamondLength}
                    distanceBetweenRects={this.state.distanceBetweenRects}
                    updateNodesArray={this.updateNodesArray}
                    openSideNav={this.openSideNav}
                    shouldUpdatedata={this.state.shouldUpdatedata}
                    updatedData={this.dataUpdated}
                    retrieveNodeState={this.retrieveNodeState}
                    workflowValidator={this.workflowValidator}
                    checkForBrokenWorkflow={checkForBrokenWorkflow}
                    workflowChecked={this.workflowChecked}
                    toggleConditionsModalVisibility={this.toggleConditionsModalVisibility}
                    loading={this.state.loading}
                />
                <WorkflowSideNav 
                    sidenavVisibility={sideNavVisible}
                    actualNode={actualNode}
                    workflowData={workflowData}
                    groups={groups}
                    processes={processes}
                    closeSidenav={this.closeSidenav}
                    saveSidenav={this.saveSidenav}
                    nodeData={this.state.nodeData}
                />
            </div>
        )
    }
}


const WorkflowHeader = styled.div`
    display: flex;
    height: 100px;
    z-index: 2;
    background: #FFFFFF;
    border: 2px solid #EEEEEE;
    align-items: center;
    font-family: Montserrat;
    .textArea{
        flex: 8;
        .workflow-name{
            border: none;
            width: 50%;
            height: 50px;
            font-family: inherit;
            font-style: normal;
            font-size: 1.3em;
            font-weight: bold;
            text-transform: uppercase;
            color: #8493AA;
            margin-left: 10%;

            ::placeholder{
                font-family: inherit;
                font-style: normal;
                font-size: 1.3em;
                font-weight: bold;
                text-transform: uppercase;
                color: #8493AA;
            }
        }
    }
    .options{
        flex: 2;
        font-family: inherit;
        .cancel{
            color: #335D7C;
            border: none;
            background: none;
            font-weight: 500;
            font-size: 1.3em;
            :hover{
                cursor: pointer;
            }
        }
        .save{
            border-radius: 20px;
            background: #335D7C;
            border: none;
            color: white;
            font-weight: 500;
            height: 40px;
            width: 113px;
            font-size: 1.2em;
            margin-left: 10%;
            :hover{
                cursor: pointer;
            }
        }
    }
`